module.exports = __webpack_public_path__ + "static/img/pc-web-img-06@w.d2a7fb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/pc-web-img-06@w.png
// module id = Hj+X
// module chunks = 0